import { Component, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { BoService } from 'src/app/services/bo-service/bo.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})
export class SignInComponent implements OnInit {

  constructor(private userStorageService: UserStorageService,
              private boService: BoService,
              private securityService: SecurityService) { }

  ngOnInit() {
    this.userStorageService.deleteAllItems();
    this.userStorageService.setLang(this.boService.getLanguage());
    this.securityService.genUDID().subscribe(
      (udid) => {
        this.userStorageService.setUDID(udid);
      }
    );
  }

}
